export type Language = 'bg' | 'en';

export const translations = {
  bg: {
    // Navigation
    nav: {
      services: 'Услуги',
      pricing: 'Цени',
      about: 'За нас',
      contact: 'Контакти',
      backToHome: '← Обратно към началото',
    },
    // Hero Section
    hero: {
      title: 'Професионални фулфилмънт услуги за вашия бизнес',
      subtitle: 'Складиране, опаковане и доставка на вашите продукти с най-добрите куриерски компании',
      cta: 'Започнете сега',
      ctaSecondary: 'Научете повече',
      processFlow: {
        orderTitle: 'Процес на поръчка',
        clientOrder: 'Поръчка от клиент',
        systemCall: 'Системно извикване',
        packageItems: 'Опаковане на стоки',
        createShipment: 'Създаване на пратка',
        toCourier: 'Към куриер',
        returnTitle: 'Процес на връщане',
        receiveReturn: 'Приемане на връщане',
        inspectPhoto: 'Проверка и снимка',
        acceptReject: 'Одобрение/Отказ',
      },
      partnersLabel: 'Партньори:',
    },
    // Services Section
    services: {
      title: 'Нашите услуги',
      subtitle: 'Комплексни логистични решения за вашия онлайн бизнес',
      storage: {
        title: 'Складиране',
        description: 'Сигурно и организирано съхранение на вашите продукти в модерни складови помещения',
      },
      packaging: {
        title: 'Опаковане',
        description: 'Професионално опаковане на поръчки с възможност за персонализация и подаръчно опаковане',
      },
      shipping: {
        title: 'Доставка',
        description: 'Партньорство с водещи куриерски компании - Еконт, Спиди, DHL и други',
      },
      returns: {
        title: 'Управление на връщания',
        description: 'Безпроблемна обработка на връщания и рекламации от клиенти',
      },
      integration: {
        title: 'Интеграции',
        description: 'Интеграция с Shopify, WooCommerce и други платформи за електронна търговия',
      },
      reporting: {
        title: 'Отчети и анализи',
        description: 'Детайлни отчети за складови наличности, поръчки и доставки в реално време',
      },
    },
    // Pricing Section
    pricing: {
      title: 'Планове и цени',
      subtitle: 'Изберете плана, който отговаря на вашите нужди',
      perMonth: '/ месец',
      ctaButton: 'Започнете',
      popularBadge: 'Популярен',
      starter: {
        name: 'Starter',
        price: '51 EUR',
        description: 'Подходящ за стартиращи онлайн магазини',
        features: [
          'Складиране: до 5 палета / 1000 кутии',
          'Пратки: до 50 / месец',
          'Товарителници: Еконт, Спиди, DHL',
          'Опаковане: стандартни кутии',
          'Предаване на куриер',
          'Онлайн достъп (basic)',
        ],
      },
      growth: {
        name: 'Growth',
        price: '129 EUR',
        description: 'За развиващи се магазини',
        features: [
          'Складиране: до 10+ палета / 10 000+ кутии',
          'Пратки: до 300 / месец',
          'Персонализирано опаковане',
          'Интеграции: Shopify, WooCommerce',
          'Управление на връщания',
          'Приоритетна обработка',
        ],
      },
      pro: {
        name: 'Pro',
        price: 'от 299 EUR',
        description: 'За утвърдени e-commerce бизнеси',
        features: [
          'Гъвкаво складиране',
          '1000+ пратки / месец',
          'Индивидуален account manager',
          'ERP/CRM интеграция',
          'Gift wrapping, комплекти',
          'Курирески отстъпки',
        ],
      },
      addons: {
        title: 'Допълнителни услуги',
        items: [
          'Съхранение над лимита',
          'Premium опаковки',
          'Абонаментни кутии',
          'Kitting',
          'Международно fulfillment',
        ],
      },
    },
    // Features Section
    features: {
      title: 'Защо BoxFlow?',
      subtitle: 'Вашият надежден партньор в логистиката',
      items: [
        {
          title: 'Бърза обработка',
          description: 'Обработваме и изпращаме поръчките ви в рамките на същия ден',
        },
        {
          title: 'Прозрачност',
          description: 'Проследяване на поръчки и складови наличности в реално време',
        },
        {
          title: 'Гъвкавост',
          description: 'Персонализирани решения според вашите специфични нужди',
        },
        {
          title: 'Надеждност',
          description: 'Професионален екип с богат опит в логистиката',
        },
      ],
      stats: [
        {
          number: '1000+',
          label: 'Доставени пратки',
        },
        {
          number: '50+',
          label: 'Доволни клиенти',
        },
        {
          number: '24/7',
          label: 'Поддръжка',
        },
        {
          number: '99.9%',
          label: 'Точност',
        },
      ],
    },
    // Contact Section
    contact: {
      title: 'Свържете се с нас',
      subtitle: 'Готови сме да отговорим на всички ваши въпроси',
      phone: 'Телефон',
      email: 'Имейл',
      address: 'Адрес',
      callToAction: 'Започнете сега и оптимизирайте вашата логистика!',
      getQuote: 'Поискайте оферта',
      form: {
        name: 'Име',
        email: 'Имейл',
        phone: 'Телефон',
        message: 'Съобщение',
        submit: 'Изпрати запитване',
        submitting: 'Изпращане...',
        successMessage: 'Благодарим ви за запитването! Ще се свържем с вас скоро.',
        errorMessage: 'Неуспешно изпращане на съобщението. Моля, опитайте отново.',
        errors: {
          nameRequired: 'Името е задължително',
          nameTooShort: 'Името трябва да е поне 2 символа',
          emailRequired: 'Имейлът е задължителен',
          emailInvalid: 'Моля, въведете валиден имейл адрес',
          phoneInvalid: 'Моля, въведете валиден телефонен номер',
          phoneTooShort: 'Телефонният номер е твърде кратък',
          messageRequired: 'Съобщението е задължително',
          messageTooShort: 'Съобщението трябва да е поне 10 символа',
          messageTooLong: 'Съобщението трябва да е под 1000 символа',
        },
      },
    },
    // Footer
    footer: {
      description: 'Професионални фулфилмънт услуги за вашия онлайн бизнес',
      quickLinks: 'Бързи връзки',
      partners: 'Партньори',
      location: 'София, България',
      rights: 'Всички права запазени',
      privacy: 'Политика за поверителност',
      terms: 'Общи условия',
    },
    // Terms of Service
    termsOfService: {
      title: 'Общи условия',
      lastUpdated: 'Последна актуализация: ',
      sections: {
        introduction: {
          title: '1. Въведение',
          content: 'Добре дошли в BoxFlow. Тези Общи условия регулират използването на нашите услуги за складиране, опаковане и доставка. Използвайки нашите услуги, вие се съгласявате с тези условия.',
        },
        services: {
          title: '2. Услуги',
          content: 'BoxFlow предоставя комплексни логистични услуги, включително складиране на стоки, професионално опаковане, управление на поръчки и доставка чрез партньорски куриерски компании.',
        },
        obligations: {
          title: '3. Задължения на клиента',
          content: 'Клиентът се задължава да предоставя точна информация за стоките, да спазва изискванията за опаковане и да заплаща услугите в договорените срокове.',
        },
        liability: {
          title: '4. Отговорност',
          content: 'BoxFlow носи отговорност за сигурното съхранение и обработка на стоките съгласно приетите стандарти. Не носим отговорност за забавяне или повреди, причинени от трети страни или форсмажорни обстоятелства.',
        },
        pricing: {
          title: '5. Цени и плащане',
          content: 'Цените се определят според избрания план и допълнителните услуги. Плащането се извършва месечно, като фактурите се издават в началото на всеки период.',
        },
        termination: {
          title: '6. Прекратяване',
          content: 'Всяка страна може да прекрати договора с едномесечно предизвестие. При прекратяване клиентът е длъжен да изтегли стоките си в рамките на 30 дни.',
        },
        changes: {
          title: '7. Промени в условията',
          content: 'BoxFlow си запазва правото да променя тези условия. Клиентите ще бъдат уведомени за значителни промени поне 30 дни предварително.',
        },
        contact: {
          title: '8. Контакт',
          content: 'За въпроси относно тези условия, моля свържете се с нас на info@boxflow.bg или +359 878 686 659.',
        },
      },
    },
    // Privacy Policy
    privacyPolicy: {
      title: 'Политика за поверителност',
      lastUpdated: 'Последна актуализация: ',
      sections: {
        introduction: {
          title: '1. Въведение',
          content: 'BoxFlow се ангажира да защитава личните данни на своите клиенти. Тази политика описва как събираме, използваме и защитаваме вашата информация.',
        },
        dataCollection: {
          title: '2. Данни, които събираме',
          content: 'Събираме име, имейл адрес, телефон, адрес за доставка, информация за поръчки и стоки. Тези данни са необходими за предоставяне на нашите логистични услуги.',
        },
        dataUsage: {
          title: '3. Използване на данните',
          content: 'Използваме вашите данни за обработка на поръчки, комуникация относно услугите, подобряване на обслужването и изпълнение на законови задължения.',
        },
        dataSharing: {
          title: '4. Споделяне на данни',
          content: 'Споделяме данни само с партньорски куриерски компании за целите на доставката. Не продаваме или предоставяме личните ви данни на трети страни за маркетингови цели.',
        },
        dataSecurity: {
          title: '5. Защита на данните',
          content: 'Прилагаме технически и организационни мерки за защита на личните данни от неоторизиран достъп, загуба или злоупотреба.',
        },
        userRights: {
          title: '6. Вашите права',
          content: 'Имате право на достъп, коригиране и изтриване на личните си данни. Можете да поискате копие на данните си или да възразите срещу тяхната обработка.',
        },
        cookies: {
          title: '7. Бисквитки',
          content: 'Използваме бисквитки за подобряване на потребителското изживяване на нашия уебсайт. Можете да управлявате настройките за бисквитки през вашия браузър.',
        },
        contact: {
          title: '8. Контакт',
          content: 'За въпроси относно личните данни и тази политика, моля свържете се с нас на privacy@boxflow.bg.',
        },
      },
    },
  },
  en: {
    // Navigation
    nav: {
      services: 'Services',
      pricing: 'Pricing',
      about: 'About',
      contact: 'Contact',
      backToHome: '← Back to Home',
    },
    // Hero Section
    hero: {
      title: 'Professional fulfillment services for your business',
      subtitle: 'Storage, packaging and delivery of your products with the best courier companies',
      cta: 'Get Started',
      ctaSecondary: 'Learn More',
      processFlow: {
        orderTitle: 'Order Process',
        clientOrder: 'Client Order',
        systemCall: 'System Call',
        packageItems: 'Package Items',
        createShipment: 'Create Shipment',
        toCourier: 'To Courier',
        returnTitle: 'Return Process',
        receiveReturn: 'Receive Return',
        inspectPhoto: 'Inspect & Photo',
        acceptReject: 'Accept/Reject',
      },
      partnersLabel: 'Partners:',
    },
    // Services Section
    services: {
      title: 'Our Services',
      subtitle: 'Complete logistics solutions for your online business',
      storage: {
        title: 'Storage',
        description: 'Secure and organized storage of your products in modern warehouse facilities',
      },
      packaging: {
        title: 'Packaging',
        description: 'Professional order packaging with customization and gift wrapping options',
      },
      shipping: {
        title: 'Shipping',
        description: 'Partnership with leading courier companies - Econt, Speedy, DHL and others',
      },
      returns: {
        title: 'Returns Management',
        description: 'Seamless processing of returns and customer complaints',
      },
      integration: {
        title: 'Integrations',
        description: 'Integration with Shopify, WooCommerce and other e-commerce platforms',
      },
      reporting: {
        title: 'Reports & Analytics',
        description: 'Detailed reports on inventory, orders and deliveries in real-time',
      },
    },
    // Pricing Section
    pricing: {
      title: 'Plans & Pricing',
      subtitle: 'Choose the plan that fits your needs',
      perMonth: '/ month',
      ctaButton: 'Get Started',
      popularBadge: 'Popular',
      starter: {
        name: 'Starter',
        price: '51 EUR',
        description: 'Perfect for starting online stores',
        features: [
          'Storage: up to 5 pallets / 1000 boxes',
          'Shipments: up to 50 / month',
          'Carriers: Econt, Speedy, DHL',
          'Packaging: standard boxes',
          'Courier handover',
          'Online access (basic)',
        ],
      },
      growth: {
        name: 'Growth',
        price: '129 EUR',
        description: 'For growing stores',
        features: [
          'Storage: up to 10+ pallets / 10 000+ boxes',
          'Shipments: up to 300 / month',
          'Custom packaging',
          'Integrations: Shopify, WooCommerce',
          'Returns management',
          'Priority processing',
        ],
      },
      pro: {
        name: 'Pro',
        price: 'from 299 EUR',
        description: 'For established e-commerce businesses',
        features: [
          'Flexible storage',
          '1000+ shipments / month',
          'Dedicated account manager',
          'ERP/CRM integration',
          'Gift wrapping, kits',
          'Courier discounts',
        ],
      },
      addons: {
        title: 'Add-on Services',
        items: [
          'Storage over limit',
          'Premium packaging',
          'Subscription boxes',
          'Kitting',
          'International fulfillment',
        ],
      },
    },
    // Features Section
    features: {
      title: 'Why BoxFlow?',
      subtitle: 'Your reliable logistics partner',
      items: [
        {
          title: 'Fast Processing',
          description: 'We process and ship your orders within the same day',
        },
        {
          title: 'Transparency',
          description: 'Real-time tracking of orders and inventory',
        },
        {
          title: 'Flexibility',
          description: 'Customized solutions according to your specific needs',
        },
        {
          title: 'Reliability',
          description: 'Professional team with extensive logistics experience',
        },
      ],
      stats: [
        {
          number: '1000+',
          label: 'Packages Delivered',
        },
        {
          number: '50+',
          label: 'Happy Customers',
        },
        {
          number: '24/7',
          label: 'Support',
        },
        {
          number: '99.9%',
          label: 'Accuracy',
        },
      ],
    },
    // Contact Section
    contact: {
      title: 'Get in Touch',
      subtitle: 'We are ready to answer all your questions',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      callToAction: 'Start now and optimize your logistics!',
      getQuote: 'Get a Quote',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send Inquiry',
        submitting: 'Sending...',
        successMessage: 'Thank you for your inquiry! We will contact you soon.',
        errorMessage: 'Failed to send message. Please try again.',
        errors: {
          nameRequired: 'Name is required',
          nameTooShort: 'Name must be at least 2 characters',
          emailRequired: 'Email is required',
          emailInvalid: 'Please enter a valid email address',
          phoneInvalid: 'Please enter a valid phone number',
          phoneTooShort: 'Phone number is too short',
          messageRequired: 'Message is required',
          messageTooShort: 'Message must be at least 10 characters',
          messageTooLong: 'Message must be less than 1000 characters',
        },
      },
    },
    // Footer
    footer: {
      description: 'Professional fulfillment services for your online business',
      quickLinks: 'Quick Links',
      partners: 'Partners',
      location: 'Sofia, Bulgaria',
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
    },
    // Terms of Service
    termsOfService: {
      title: 'Terms & Conditions',
      lastUpdated: 'Last updated: ',
      sections: {
        introduction: {
          title: '1. Introduction',
          content: 'Welcome to BoxFlow. These Terms and Conditions govern the use of our storage, packaging, and delivery services. By using our services, you agree to these terms.',
        },
        services: {
          title: '2. Services',
          content: 'BoxFlow provides comprehensive logistics services, including goods storage, professional packaging, order management, and delivery through partner courier companies.',
        },
        obligations: {
          title: '3. Client Obligations',
          content: 'The client undertakes to provide accurate information about the goods, comply with packaging requirements, and pay for services within the agreed timeframe.',
        },
        liability: {
          title: '4. Liability',
          content: 'BoxFlow is responsible for the secure storage and handling of goods according to accepted standards. We are not liable for delays or damage caused by third parties or force majeure circumstances.',
        },
        pricing: {
          title: '5. Pricing and Payment',
          content: 'Prices are determined according to the selected plan and additional services. Payment is made monthly, with invoices issued at the beginning of each period.',
        },
        termination: {
          title: '6. Termination',
          content: 'Either party may terminate the agreement with one month notice. Upon termination, the client must retrieve their goods within 30 days.',
        },
        changes: {
          title: '7. Changes to Terms',
          content: 'BoxFlow reserves the right to modify these terms. Clients will be notified of significant changes at least 30 days in advance.',
        },
        contact: {
          title: '8. Contact',
          content: 'For questions regarding these terms, please contact us at info@boxflow.bg or +359 878 686 659.',
        },
      },
    },
    // Privacy Policy
    privacyPolicy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: ',
      sections: {
        introduction: {
          title: '1. Introduction',
          content: 'BoxFlow is committed to protecting the personal data of its clients. This policy describes how we collect, use, and protect your information.',
        },
        dataCollection: {
          title: '2. Data We Collect',
          content: 'We collect name, email address, phone, delivery address, order and goods information. This data is necessary to provide our logistics services.',
        },
        dataUsage: {
          title: '3. Data Usage',
          content: 'We use your data for order processing, service-related communication, service improvement, and fulfilling legal obligations.',
        },
        dataSharing: {
          title: '4. Data Sharing',
          content: 'We share data only with partner courier companies for delivery purposes. We do not sell or provide your personal data to third parties for marketing purposes.',
        },
        dataSecurity: {
          title: '5. Data Security',
          content: 'We implement technical and organizational measures to protect personal data from unauthorized access, loss, or misuse.',
        },
        userRights: {
          title: '6. Your Rights',
          content: 'You have the right to access, correct, and delete your personal data. You can request a copy of your data or object to its processing.',
        },
        cookies: {
          title: '7. Cookies',
          content: 'We use cookies to improve the user experience on our website. You can manage cookie settings through your browser.',
        },
        contact: {
          title: '8. Contact',
          content: 'For questions about personal data and this policy, please contact us at privacy@boxflow.bg.',
        },
      },
    },
  },
};

